import { Alert, Divider, Empty, notification, Typography } from 'antd'
import * as Styles from './styles'
import { ServiceCard } from './ServiceCard'
import { ServiceCategory } from 'src/common/models/serviceCategory'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/state/reducer'
import { serviceLoading } from 'src/common/apiLoader/state/selection'
import { GET_SERVICE_CATEGORIES_API } from 'src/features/Service/state/actionTypes'
import { useEffect, useState } from 'react'
import { getServiceCategoriesApi, getServicesApi } from 'src/features/Service/state/action'
import { Service } from 'src/common/models/service'
import { ContractDetail, ServiceContract } from 'src/common/models/contract'
import { updateCurrentContract } from '../../state/action'
import { v4 as uuidv4 } from 'uuid';
import { SystemDescriptions } from 'src/common/descriptions'
import { ServiceContractError, ServiceContractErrorOrigin } from '../../state/types'
import { CategorySelector } from './CategprySelector'

export type ReduxProps = {
    serviceCategories?: ServiceCategory[],
    isGettingCategories: boolean,
    services?: Service[],
    currentContract?: Partial<ServiceContract>
    error?: ServiceContractError
}

export const ServicesSection = () => {
    const dispatch = useDispatch()

    // const [selectedCategory, setSelectedCategory] = useState<ServiceCategory | undefined>()
    const [currentServices, setCurrentServices] = useState<Service[] | undefined>()

    useEffect(() => {
        dispatch(getServiceCategoriesApi())
        dispatch(getServicesApi())
    }, [])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        serviceCategories: state.service.serviceCategories,
        isGettingCategories: serviceLoading(state, [GET_SERVICE_CATEGORIES_API]),
        services: state.service.services,
        currentContract: state.serviceContract.currentContract,
        error: state.serviceContract.error,
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    // useEffect(() => {
    //     if (selectedCategory) {
    //         const currentServices = reduxProps?.services?.sort((a, b) => a.name.localeCompare(b.name))
    //             .filter(service => service.serviceCategoryId === selectedCategory.id)
    //         setCurrentServices(currentServices)
    //     }
    // }, [selectedCategory])

    const renderHeaderSection = () => (
        <CategorySelector
            text={descriptions.LOADING}
            onAccept={(category: ServiceCategory) => {
                if (category) {
                    const currentServices = reduxProps?.services?.sort((a, b) => a.name.localeCompare(b.name))
                        .filter(service => service.serviceCategoryId === category.id)
                    setCurrentServices(currentServices)
                }
            }}
        />
    )

    const openNotification = (message: string, description: string) => {
        notification.error({
            message,
            description,
        });
    };

    const handleServiceItemClick = (service: Service) => {

        const foundInDetail = reduxProps.currentContract?.detail?.find(candidate => candidate.serviceId === service.id)

        if (foundInDetail) {
            openNotification(
                descriptions.VALIDATIONS.WARNING_TITLE,
                descriptions.VALIDATIONS.SERVICE_ALREADY_IN_DETAIL(foundInDetail.serviceName),
            )
            return
        }

        const foundWithDifferentCycle = reduxProps.currentContract?.detail?.some(item => item.isMonthly !== service.isMonthly)

        if (foundWithDifferentCycle) {
            openNotification(
                descriptions.VALIDATIONS.WARNING_TITLE,
                descriptions.VALIDATIONS.SAME_TYPE_SERVICE,
            )
            return
        }

        const hasContractCycle = Object.prototype.hasOwnProperty.call(reduxProps.currentContract || {}, "isMonthly")

        if (hasContractCycle && Boolean(reduxProps.currentContract?.isMonthly) !== Boolean(service.isMonthly)) {
            openNotification(
                descriptions.VALIDATIONS.WARNING_TITLE,
                descriptions.VALIDATIONS.MISMATCH_MONTHLY_AND_SERVICE_TYPE,
            )
            return
        }

        const currentDetail = reduxProps.currentContract?.detail || []

        const newDetail = [
            ...currentDetail,
            {
                serviceId: service.id!,
                price: service.price,
                qty: 1,
                total: service.price,
                characteristics: [...service.characteristics],
                serviceName: service.name,
                ref: uuidv4(),
                imageUrl: service.imageUrl,
                externalId: service.externalId,
                isMonthly: service.isMonthly,
            },
        ]

        let total: number = 0
        const categoriesOnDetailIds: number[] = []
        const servicesInDetailIds: string[] = []

        newDetail.forEach((item: ContractDetail) => {
            total = total + item.price
            categoriesOnDetailIds.push(service.serviceCategoryId)
            servicesInDetailIds.push(item.serviceId.toString())
        })

        dispatch(updateCurrentContract({
            detail: newDetail,
            total,
            categoriesInDetailIds: categoriesOnDetailIds.join(','),
            servicesInDetailIds: servicesInDetailIds.join(','),
        }))
    }

    const renderEmptySection = (type: "NO_CATEGORY_SELECTED" | "NO_SERVICES") => (
        <Styles.NoCategorySelectedContainer>
            <Empty
                styles={{ image: { height: 60 } }}
                description={
                    <Typography.Text>
                        {
                            type === "NO_CATEGORY_SELECTED"
                                ? descriptions.EMPTY_STATES.NO_CATEGORY_SELECTED
                                : descriptions.EMPTY_STATES.NO_SERVICES_FOR_CATEGORY('')
                        }

                    </Typography.Text>
                }
            >
            </Empty>
        </Styles.NoCategorySelectedContainer>
    )

    const renderServicesSection = () => (
        <Styles.ServicesContainer>
            {
                !currentServices
                    ? renderEmptySection("NO_CATEGORY_SELECTED")
                    : currentServices.length === 0
                        ? renderEmptySection("NO_SERVICES")
                        : currentServices?.map(service => <ServiceCard
                            key={service.id}
                            service={service}
                            onClick={handleServiceItemClick}
                        />)
            }
        </Styles.ServicesContainer>
    )

    return (
        <>
            {renderHeaderSection()}
            <Divider />
            {
                reduxProps.error && reduxProps.error.type === ServiceContractErrorOrigin.CREATE_SERVICE_CONTRACT &&
                <Alert
                    message={descriptions.VALIDATIONS.ERROR_TITLE}
                    description={reduxProps.error.detail?.message || ''}
                    type="error"
                    showIcon
                    style={{
                        marginBottom: 16,
                        marginRight: 8,
                    }}
                />
            }
            {renderServicesSection()}
        </>
    )
}
